import { outlinedInputClasses, styled, TextField } from '@mui/material'
import { gecinaBlueMain } from '../../../theme'

export const StyledTextFieldFormFile = styled(TextField)({
	'& input[type=number]': {
		WebkitAppearance: 'none'
	},
	'& input[type=number]::-webkit-outer-spin-button': {
		WebkitAppearance: 'none',
		margin: 0
	},
	'& input[type=number]::-webkit-inner-spin-button': {
		WebkitAppearance: 'none',
		margin: 0
	},
	[`.${outlinedInputClasses.root}`]: {
		width: '30px',
		height: '30px',
		border: `1px solid ${gecinaBlueMain}`,
		borderRadius: '4px',
		fontFamily: 'Montserrat',
		fontSize: 14,
		color: gecinaBlueMain,
		'&.Mui-disabled': {
			background: '#E6E6E6',
			border: '1px solid #515151'
		}
	},
	[`.${outlinedInputClasses.input}`]: {
		padding: '5px',
		textAlign: 'center'
	},
	[`.${outlinedInputClasses.notchedOutline}`]: {
		border: 'none'
	}
})